import {useCallback} from "react";
import {debounce} from "lodash";

const  useDebounceFunction = (callback, timeout = 500) => {
    // eslint-disable-next-line
    return useCallback(debounce(callback, timeout), []);
}

export {useDebounceFunction}